import { Injectable } from '@angular/core';

import {
	CreateEdgeTypeRequest,
	UpdateEdgeTypeRequest,
} from '@reach/interfaces/edge-types/edge-types.requests';
import {
	CreateEdgeTypeResponse,
	GetEdgeTypesResponse,
	UpdateEdgeTypeResponse,
} from '@reach/interfaces/edge-types/edge-types.responses';
import { EdgeTypeInterface } from '@reach/interfaces/edge-types/edge-types.types';
import { CreateEdgeRequestInterface } from '@reach/interfaces/edges/edges.requests';
import {
	CreateManyEdgesResponse,
	DeleteManyEdgesResponse,
} from '@reach/interfaces/edges/edges.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class EdgesApiService extends BaseApiService {
	protected commonPath = ['edges'];
	private readonly edgeTypesUrl = this.urlFnGenerator(['edge-types']);

	public async createNew(sourceId: ReachNodeId, targetId: ReachNodeId): Promise<void> {
		const body = {
			jumps: 1,
			directed: false,
			source: sourceId,
			target: targetId,
		};
		return await this.http.post(this.url(), body);
	}

	public async createMany(edges: CreateEdgeRequestInterface[]): Promise<CreateManyEdgesResponse> {
		const body = { edges };
		return await this.http.post<CreateManyEdgesResponse>(this.url('many'), body);
	}

	public async removeEdges(edgeIds: string[]): Promise<DeleteManyEdgesResponse> {
		const body = { edgeIds };
		return await this.http.post<DeleteManyEdgesResponse>(this.url('delete-many'), body);
	}

	public async getEdgeTypes(): Promise<GetEdgeTypesResponse> {
		return await this.http.get<GetEdgeTypesResponse>(this.edgeTypesUrl());
	}

	public async createEdgeType(payload: CreateEdgeTypeRequest): Promise<CreateEdgeTypeResponse> {
		return await this.http.post<CreateEdgeTypeResponse>(this.edgeTypesUrl(), payload);
	}

	public async updateEdgeType(
		id: EdgeTypeInterface['id'],
		payload: UpdateEdgeTypeRequest
	): Promise<UpdateEdgeTypeResponse> {
		return await this.http.patch<UpdateEdgeTypeResponse>(this.edgeTypesUrl(id), payload);
	}

	public async deleteEdgeType(id: EdgeTypeInterface['id']): Promise<void> {
		return await this.http.delete(this.edgeTypesUrl(id));
	}

	public async deleteEdges(edgeIds: string[]): Promise<void> {
		return await this.http.delete(this.edgeTypesUrl('delete-many'), { body: { edgeIds } });
	}
}
